import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPaloaltosoftwareComponent } from './simple-icons-paloaltosoftware.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPaloaltosoftwareComponent ],
    exports:      [ SimpleIconsPaloaltosoftwareComponent ],
    bootstrap:    []
})
export class SimpleIconsPaloaltosoftwareModule {}
